import {
  BUSINESS_GET_ARTICLES_REQUEST,
  BUSINESS_GET_ARTICLES_SUCCESS,
  BUSINESS_GET_ARTICLES_FAIL,
  BUSINESS_REMOVE_ARTICLE_REQUEST,
  BUSINESS_REMOVE_ARTICLE_SUCCESS,
  BUSINESS_REMOVE_ARTICLE_FAIL,
  BUSINESS_GET_ARTICLE_REQUEST,
  BUSINESS_GET_ARTICLE_SUCCESS,
  BUSINESS_GET_ARTICLE_FAIL,
  BUSINESS_EDIT_ARTICLE_REQUEST,
  BUSINESS_EDIT_ARTICLE_SUCCESS,
  BUSINESS_EDIT_ARTICLE_FAIL,
  BUSINESS_CREATE_ARTICLE_REQUEST,
  BUSINESS_CREATE_ARTICLE_SUCCESS,
  BUSINESS_CREATE_ARTICLE_FAIL
} from "../actions/business";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [
    {
      id: 0,
      name: "top",
      display_name: "頂部廣告"
    },
    {
      id: 1,
      name: "right",
      display_name: "側邊廣告"
    }
  ],
  areaOptions: ["general", "tv"],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {},

  editArticleRequest: false,
  successBackMsg: ""
};

const business = (state = initialState, action) => {
  switch (action.type) {
    case BUSINESS_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case BUSINESS_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        articles: action.data.data,
        articlesPagination: {
          currentPage: action.data.current_page,
          lastPage: action.data.last_page
        }
      };
    case BUSINESS_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors
      };
    case BUSINESS_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {},
        selectedArticle: {}
      };
    case BUSINESS_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedArticle: {}
      };
    case BUSINESS_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedArticle: {}
      };

    case BUSINESS_GET_ARTICLE_REQUEST:
      return {
        ...state,
        getArticleRequest: true,
        successMsg: "",
        errorMsg: "",
        errors: {},
        selectedArticle: {}
      };
    case BUSINESS_GET_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticleRequest: false,
        successMsg: "",
        errorMsg: "",
        errors: {},
        selectedArticle: action.data
      };
    case BUSINESS_GET_ARTICLE_FAIL:
      return {
        ...state,
        getArticleRequest: false,
        successMsg: "",
        errorMsg: action.msg,
        errors: action.errors,
        selectedArticle: {}
      };
    case BUSINESS_EDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case BUSINESS_EDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case BUSINESS_EDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };
    case BUSINESS_CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case BUSINESS_CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case BUSINESS_CREATE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };

    default:
      return state;
  }
};

export default business;
